import { io } from 'socket.io-client';

class SocketioService {
  constructor() {}

  setupSocketConnection(loggedInUser, locale) {
    //   console.log("Connector accessed " + process.env.local.VUE_APP_SOCKET_ENDPOINT)
    this.socket = io(process.env.VUE_APP_API_ENDPOINT_STARTER + "",
    {
        query : {
            lawyer_id : loggedInUser,
            locale: locale
        }
    });

    

  }
}

export default new SocketioService();